import { Component, OnInit, EventEmitter, Input, Output, HostListener, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { GDPR_Data } from 'src/app/common-class/corp-setting';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
declare var $: any;

@Component({
  selector: 'app-gdpr',
  templateUrl: './gdpr.component.html',
  styleUrls: ['./gdpr.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class GDPRComponent implements OnInit {
  //@Input() Message: string
  @Input() Header:string;
  @Input() GDPRData: GDPR_Data;

  @Output() showGDPR: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private service: ParticipationDataService,private elementref : ElementRef) { }

  ngOnInit() {
    //this.Message = JSON.parse(this.Message);
    // setTimeout(() => {
    //   $('body').getNiceScroll().resize();
    // }, 250);
  }
  ngAfterViewChecked(){
    $('.anonymous-modal').niceScroll({
      background: 'transparent',
      cursorcolor: '#7f7f7f',
      cursorwidth: '10px',
      autohidemode: false
    });
  }

  Close() {
    $('.modalWindow').getNiceScroll().remove();
    this.showGDPR.emit(false);
  }

  CloseKeyboard(event){
    if(event.keyCode == 13 || event.keyCode == 32){
      this.Close();
    }
  }

  @HostListener("keydown",['$event'])
  trapFocus(event:KeyboardEvent){
    let focusableElements = this.elementref.nativeElement.querySelectorAll('a[href]:not([disabled]), button:not([disabled]),div[role=button]')

    let firstFocusableEl = focusableElements[0];
    let lastFocusableEl = focusableElements[focusableElements.length - 1];

    if(event.keyCode == 9){
      if (event.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          event.preventDefault();
        }
      }
      else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          event.preventDefault();
        }
      }
    }
  }

}
